import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { en } from './en';
import { ko } from './ko';

const getNativeLocale = (): string | null => {
  if (typeof window === 'undefined') return null;
  const info = (window as unknown as Record<string, unknown>)
    .__LEMOMENT_DEVICE_INFO__ as { locale?: string } | null;
  return info?.locale ?? null;
};

const nativeAppDetector = {
  name: 'nativeApp',
  lookup: (): string | undefined => {
    const locale = getNativeLocale();
    if (!locale) return undefined;
    return locale.split('-')[0];
  },
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(nativeAppDetector);

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ko: { translation: ko },
    },
    fallbackLng: 'ko',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'nativeApp'],
      lookupLocalStorage: 'lemoment_language',
      caches: ['localStorage'],
    },
  });

export { i18n };
